import { get, identity } from 'lodash';

// @todo: variables validation
export const reduceVariables = (executeFunction, queryObject) => (variables) => {
  const reducer = get(queryObject, 'reducer', identity);
  return executeFunction(reducer(variables));
};

